<template>
  <div class="news">
    <div class="news-nav">
      <div class="news-nav-content">
        <div class="news-nav-content-left">
          <div @click="goBack">新闻中心</div>
          <div>&gt;</div>
          <div>{{detail.title}}</div>
        </div>
        <div class="news-nav-content-right" @click="goBack">返回</div>
      </div>     
    </div>
    <div class="news-center">
      <div class="news-center-title">{{detail.title}}</div>
      <div class="news-center-time">发布时间: {{detail.date.year}}-{{detail.date.month}}-{{detail.date.day}}</div>
      <img :src="detail.img" alt="">
      <div class="news-center-content" v-html="detail.content"></div>
      <!-- <div class="news-center-foot">
        <div>&lt; 上一条:</div>
        <div>下一条: &gt;</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      detail:{
        img:require(`../../assets/img/news1.png`),
        title:'2021年上海新场镇民宿改造项目勘察测绘',
        abstract:'2021年6月23至25日，自然资源部测绘标准化研究所在江苏太仓组织召开《测绘成果汇交规范》《民生埃里克森的房间昂克赛拉JFK拉萨的',
        content:'2021年6月23至25日，自然资源部测绘标准化研究所在江苏太仓组织召开《测绘成果汇交规范》《民生埃里克森的房间昂克赛拉JFK拉萨的',
        data:{}
      }
    }
  },
  created(){
    window.scrollTo(0,0);
    if(this.$route.params.detail===undefined){
      this.$router.push({name:'news'})
      return 
    }
    this.detail=this.$route.params.detail
  },
  methods:{
    changeIndex(i){
      this.currentIndex = i
    },  
    goBack(){
      this.$router.push({name:'news'})
    } , 
  },
  filters: {
    dataFormat(date,type) {
      let day=date.split("T")[0].split("-")
      if (type == 'd') { //返回天
        return day[2];
      } else { //返回日月
        return day[1]+','+day[0];
      }
        
    }
  }
};
</script>

<style lang="scss" scoped>
.news{
  width:100%;
  height: auto;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  background: #F6F6F6;
  &-nav{
    width: 100%;
    margin: auto;
    padding: 0.3rem 0;
    background: #fff;
    margin-bottom: 0.5rem;
    &-content{
      width: 12rem;
      margin: auto;      
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.13rem;
      color: #999;
      &-left{
        display: flex;
        align-items: center;
        >div{
          margin: 0 0.1rem;          
        }
        >div:nth-child(1){
          cursor: pointer;
        }
        >div:nth-child(1):hover{
          color: #FFBE00;
        }
      }
      &-right{
        cursor: pointer;
      }
      &-right:hover{
        color: #FFBE00;
      }
    }
    
  }
  &-center{
    width: 12rem;
    margin: auto;
    &-title{
      font-size: 0.33rem;
      color: #333;
      font-weight: 500;
    }
    &-time{
      font-size: 0.14rem;
      color: #999999;
      font-weight: 400;
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #ccc;
      margin-top: 0.2rem;
      margin-bottom: 0.3rem;
    }
    &-content{
      padding-bottom: 0.5rem;
      border-bottom: 1px solid #ccc;
      margin-bottom: 0.4rem;
      margin-top: 0.2rem;
    }
    &-foot{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.14rem;
      color: #666666;
      font-weight: 400;
    }
  }
}
</style>
